import React from "react";
import {Select,} from "antd";
import {Link} from "react-router-dom";
import {GeneratorDataManage} from "./generator_data/GeneratorDataManage";
import {FacilityDataManage} from "./facility_data/FacilityDataManage";
import {BillToDataManage} from "./bill_to/BillToDataManage";
import {TruckTypeDataManage} from "./truck_type/TruckTypeDataManage";
import {PaymentMethodDataManage} from "./payment_method/PaymentMethodDataManage";
import {WasteStreamDataManage} from "./waste_stream_data/WasteStreamDataManage";
import {TransporterDataManage} from "./transporter/TransporterDataManage";
import {ServiceTypeDataManage} from "./service_type/ServiceTypeDataManage";
import {JobDescriptionDataManage} from "./job_description/JobDescriptionDataManage";
import {ContainerTypeDataManage} from "./cantainer_type/ContainerTypeDataManage";
import {TrackHeaderLink} from "../TrackHeaderLink";

const Option = Select.Option;


export class DataManagement extends React.Component {
  state = {
    selected_value: ''
  }
  handleSelect = (value) => {
    this.setState({selected_value: value})
  }

  renderComponent() {
    const {selected_value} = this.state;
    if (selected_value === "generator") {
      return <GeneratorDataManage/>
    }
    else if (selected_value === "facility") {
      return <FacilityDataManage/>
    }
    else if (selected_value === "truck_type") {
      return <TruckTypeDataManage/>
    }
    else if (selected_value === "bill_to") {
      return <BillToDataManage/>
    }
    else if (selected_value === "payment_method") {
      return <PaymentMethodDataManage/>
    }
    else if (selected_value === "container_type") {
      return <ContainerTypeDataManage/>
    }
    else if (selected_value === "waste_stream") {
      return <WasteStreamDataManage/>
    }
    else if (selected_value === "transporter") {
      return <TransporterDataManage/>
    }
    else if (selected_value === "service_type") {
      return <ServiceTypeDataManage/>
    }
    else if (selected_value === "job_description") {
      return <JobDescriptionDataManage/>
    }

  }

  render() {
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-2 col-12">
                <h3 className="main-heading">AB Tracks</h3>
              </div>
              <div className="col-sm-10 col-12">
                <TrackHeaderLink />
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-sm-3 col-xs-12">
                <div className="select-explore-div">
                  <Select showSearch style={{width: "100%"}} placeholder="Select Data Category"
                          optionFilterProp="children" onSelect={this.handleSelect}>
                    <Option value="generator">Generator</Option>
                    <Option value="facility">Facility</Option>
                    <Option value="bill_to">Bill To</Option>
                    <Option value="truck_type">Truck Type</Option>
                    <Option value="payment_method">Payment Method</Option>
                    <Option value="container_type">Container</Option>
                    <Option value="waste_stream">Waste Streams</Option>
                    <Option value="service_type">Service Type</Option>
                    <Option value="transporter">Transporter</Option>
                    <Option value="job_description">Job Description</Option>
                  </Select>
                </div>
              </div>
              {this.renderComponent()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/DataManagement.jsx